import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
let Autocomplete = class Autocomplete extends Vue {
    constructor() {
        super(...arguments);
        this.currentInput = '';
    }
    change(value) {
        const item = this.srcList.find((v) => v[this.showText] == value);
        this.$emit('select', item);
    }
    input(value) {
        if (value) {
            for (let i = this.srcList.length - 1; i >= 0; i--) {
                if (this.srcList[i].type === 'input') {
                    this.srcList.splice(i, 1);
                }
            }
            this.currentInput = value;
            this.srcList.push({
                type: 'input',
                [this.showText]: this.currentInput
            });
        }
    }
    mounted() {
    }
    async created() {
    }
};
__decorate([
    Prop({ default: () => [] })
], Autocomplete.prototype, "srcList", void 0);
__decorate([
    Prop({ default: () => 'name' })
], Autocomplete.prototype, "showText", void 0);
__decorate([
    Prop({ default: () => '输入或选择' })
], Autocomplete.prototype, "holderText", void 0);
Autocomplete = __decorate([
    Component({})
], Autocomplete);
export default Autocomplete;
